import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Palette, DollarSign, Sliders, Megaphone, Users, BarChart3, LogOut, ChevronLeft, Activity } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const NAV = [
    { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, exact: true, testId: 'admin-nav-dashboard' },
    { to: '/admin/branding', label: 'Apariencia', icon: Palette, testId: 'admin-nav-branding' },
    { to: '/admin/plans', label: 'Planes & Precios', icon: DollarSign, testId: 'admin-nav-plans' },
    { to: '/admin/limits', label: 'Límites Free', icon: Sliders, testId: 'admin-nav-limits' },
    { to: '/admin/ads', label: 'Anuncios', icon: Megaphone, testId: 'admin-nav-ads' },
    { to: '/admin/users', label: 'Usuarios', icon: Users, testId: 'admin-nav-users' },
    { to: '/admin/broadcasts', label: 'Mensajes', icon: Megaphone, testId: 'admin-nav-broadcasts' },
    { to: '/admin/events', label: 'Analytics', icon: Activity, testId: 'admin-nav-events' },
    { to: '/admin/metrics', label: 'Métricas', icon: BarChart3, testId: 'admin-nav-metrics' },
];

export default function AdminLayout({ children, title }) {
    const { pathname } = useLocation();
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex" data-testid="admin-layout">
            <aside className="hidden md:flex flex-col w-64 bg-brand-navy text-white p-5">
                <div className="flex items-center gap-2 mb-8">
                    <span className="text-lg font-bold">4everSync</span>
                    <span className="text-[10px] uppercase tracking-widest bg-white/10 px-2 py-0.5 rounded">Admin</span>
                </div>
                <nav className="space-y-1 flex-1">
                    {NAV.map((n) => {
                        const active = n.exact ? pathname === n.to : pathname.startsWith(n.to);
                        const Icon = n.icon;
                        return (
                            <Link
                                key={n.to}
                                to={n.to}
                                data-testid={n.testId}
                                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition ${active ? 'bg-white text-brand-navy font-bold' : 'text-white/80 hover:bg-white/10'}`}
                            >
                                <Icon className="w-4 h-4" />
                                {n.label}
                            </Link>
                        );
                    })}
                </nav>
                <div className="border-t border-white/10 pt-4 text-xs">
                    <p className="text-white/60 mb-1">Conectado como</p>
                    <p className="font-bold truncate">{user?.email}</p>
                    <button
                        onClick={() => { logout(); navigate('/login'); }}
                        className="mt-3 flex items-center gap-2 text-white/70 hover:text-white"
                        data-testid="admin-logout"
                    >
                        <LogOut className="w-3.5 h-3.5" /> Salir
                    </button>
                </div>
            </aside>

            <main className="flex-1 min-w-0 flex flex-col">
                <header className="bg-white border-b border-gray-200 px-6 py-4 flex items-center gap-3 sticky top-0 z-10">
                    <button onClick={() => navigate(-1)} className="md:hidden w-9 h-9 rounded-full hover:bg-gray-100 flex items-center justify-center">
                        <ChevronLeft className="w-5 h-5 text-brand-navy" />
                    </button>
                    <h1 className="text-xl font-bold text-brand-navy">{title}</h1>
                </header>
                <div className="flex-1 p-6 max-w-5xl w-full mx-auto">{children}</div>
            </main>
        </div>
    );
}
